<template>
  <v-row class="px-4 pb-2 py-1">
    <v-col cols="12">
      <v-autocomplete
        v-model="sms_template"
        :items="smsTemplates"
        clearable
        outlined
        item-text="text"
        dense
        label="SMS Mall"
        class="pt-1"
        :messages="!dua_reason_code ? 'Välj orsak först' : undefined"
        :disabled="item.missing || !dua_reason_code"
        :loading="$apollo.loading"
        @clear="() => (sms_template = null)"
      />
    </v-col>
  </v-row>
</template>

<script>
import { get } from 'vuex-pathify'
import { format } from 'date-fns'
import gql from 'graphql-tag'

const getSet = prop => ({
  get() {
    return this.form[this.uuid].data[prop]
  },

  set(v) {
    let value = v
    if (!value || !value.length) {
      value = null
    }
    const form = Object.assign({}, this.form)
    form[this.uuid].data[prop] = value?.text || null
    this.$store.dispatch('smsMessage/updateForm', {
      uuid: this.uuid,
      prop,
      value
    })

    form[this.uuid].data['sms_text'] = value?.value || null
    this.$store.dispatch('smsMessage/updateForm', {
      uuid: this.uuid,
      prop: 'sms_text',
      value
    })
  }
})

export default {
  name: 'SmsMessageTemplateField',

  props: {
    item: Object,
    uuid: String,
    itemData: Object
  },

  apollo: {
    duaReasonCodes: {
      query: gql`
        query duaReasonCodes {
          duaReasonCodes {
            code
            text
          }
        }
      `
    }
  },

  computed: {
    form: get('smsMessage/form'),
    selectedDistrictId: get('app/selectedDistrictId'),

    model: get('smsMessage/model'),

    sms_template: {
      ...getSet('sms_template')
    },

    dua_reason_code() {
      return this.form[this.uuid].data.reason_code
    },

    smsTemplates() {
      const trainNumber = this.itemData.train_number
      const reason = (this.duaReasonCodes || []).find(
        x => x.code === this.dua_reason_code
      )?.text
      const templates =
        this.selectedDistrictId === 19
          ? [
              {
                text: `Ditt tåg {{ tåg }} är inställt. Orsaken är {{ orsak }}. Du hänvisas till nästa avgång med X-Tåget. Din nuvarande biljett gäller. https://xtrafik.se/`,
                value: `Ditt tåg ${trainNumber} är inställt. Orsaken är ${reason}. Du hänvisas till nästa avgång med X-Tåget. Din nuvarande biljett gäller.\n\nhttps://xtrafik.se/`
              },
              {
                text: `Ditt tåg {{ tåg }} är tyvärr försenat. Orsaken är {{ orsak }}. https://xtrafik.se/`,
                value: `Ditt tåg ${trainNumber} är tyvärr försenat. Orsaken är ${reason}.\n\nhttps://xtrafik.se/`
              },
              {
                text: `Du har tidigare fått information från oss att ditt tåg {{ tåg }} är inställt. Vi kan nu glädjande meddela att vi har lyckats lösa situationen så att tåget kommer gå enligt ordinarie tidtabell. Trevlig resa! https://xtrafik.se/`,
                value: `Du har tidigare fått information från oss att ditt tåg ${trainNumber} är inställt. Vi kan nu glädjande meddela att vi har lyckats lösa situationen så att tåget kommer gå enligt ordinarie tidtabell. Trevlig resa!\n\nhttps://xtrafik.se/`
              },
              {
                text: `Ditt tåg {{ tåg }} är inställt. Orsaken är {{ orsak }}. Om möjligt ber vi dig ta en tidigare avgång för din första delsträcka så att du hinner med din anslutning. Din nuvarande biljett gäller på sträckan med X-Tåget. https://xtrafik.se/`,
                value: `Ditt tåg ${trainNumber} är inställt. Orsaken är ${reason}. Om möjligt ber vi dig ta en tidigare avgång för din första delsträcka så att du hinner med din anslutning. Din nuvarande biljett gäller på sträckan med X-Tåget.\n\nhttps://xtrafik.se/`
              },
              {
                text: `Ditt tåg {{ tåg }} är inställt. Orsaken är {{ orsak }}. Buss ersätter. https://xtrafik.se/`,
                value: `Ditt tåg ${trainNumber} är inställt. Orsaken är ${reason}. Buss ersätter.\n\nhttps://xtrafik.se/`
              },
              {
                text: `Ditt tåg {{ tåg }} är inställt. Orsaken är {{ orsak }}. Invänta ersättningsbuss. Uppmärksamma information på skyltar och i utrop. https://xtrafik.se/`,
                value: `Ditt tåg ${trainNumber} är inställt. Orsaken är ${reason}. Invänta ersättningsbuss. Uppmärksamma information på skyltar och i utrop.\n\nhttps://xtrafik.se/`
              },
              {
                text: `Ditt tåg {{ tåg }} är inställt. Orsaken är {{ orsak }}. Du hänvisas till nästa avgång med X-Tåget. Din nuvarande biljett gäller. https://xtrafik.se/`,
                value: `Ditt tåg ${trainNumber} är inställt. Orsaken är ${reason}. Du hänvisas till nästa avgång med X-Tåget. Din nuvarande biljett gäller.\n\nhttps://xtrafik.se/`
              }
            ]
          : [
              {
                text: `Ditt tåg {{ tåg }} är inställt. Orsaken är {{ orsak }}. Du hänvisas till nästa avgång med Tåg i Bergslagen. Din nuvarande biljett gäller. För mer information se www.tagibergslagen.se.`,

                value: `Ditt tåg ${trainNumber} är inställt. Orsaken är ${reason}. Du hänvisas till nästa avgång med Tåg i Bergslagen.

Din nuvarande biljett gäller.
För mer information se www.tagibergslagen.se.`
              },
              {
                text: `Försenat tåg: Ditt tåg {{ tåg }} är tyvärr försenat. Orsaken är {{ orsak }}. För mer information se tagibergslagen.se/trafikinformation.`,
                value: `Försenat tåg: Ditt tåg ${trainNumber} är tyvärr försenat. Orsaken är ${reason}.\n\nFör mer information se tagibergslagen.se/trafikinformation.`
              },
              {
                text: `Återinsatt avgång: Du har tidigare fått information från oss att ditt tåg {{ tåg }} är inställt. Vi kan nu glädjande meddela att vi har lyckats lösa situationen så att tåget kommer gå enligt ordinarie tidtabell. Trevlig resa!`,
                value: `Återinsatt avgång: Du har tidigare fått information från oss att ditt tåg ${trainNumber} är inställt. Vi kan nu glädjande meddela att vi har lyckats lösa situationen så att tåget kommer gå enligt ordinarie tidtabell. Trevlig resa!`
              },
              {
                text: `Inställt tåg vädjan bytesresenärer: Ditt tåg {{ tåg }} är inställt. Orsaken är {{ orsak }}. Om möjligt ber vi dig ta en tidigare avgång för din första delsträcka så att du hinner med din anslutning. Din nuvarande biljett gäller på sträckan med Tåg i Bergslagen. För mer information se www.tagibergslagen.se/trafikinformation`,
                value: `Inställt tåg vädjan bytesresenärer: Ditt tåg ${trainNumber} är inställt. Orsaken är ${reason}. Om möjligt ber vi dig ta en tidigare avgång för din första delsträcka så att du hinner med din anslutning. Din nuvarande biljett gäller på sträckan med Tåg i Bergslagen.\n\nFör mer information se www.tagibergslagen.se/trafikinformation`
              },
              {
                text: `Inställt tåg - Buss ersätter, tidtabell finns: Ditt tåg {{ tåg }} är inställt. Orsaken är {{ orsak }}. Buss ersätter. Sök på ditt tåg på www.tagibergslagen.se/trafikinformation.`,
                value: `Inställt tåg - Buss ersätter, tidtabell finns: Ditt tåg ${trainNumber} är inställt. Orsaken är ${reason}. Buss ersätter. Sök på ditt tåg på www.tagibergslagen.se/trafikinformation.`
              },
              {
                text: `Inställt tåg-Buss ersätter, ingen tidtabell finns: Ditt tåg {{ tåg }} är inställt. Orsaken är {{ orsak }}. Invänta ersättningsbuss. Uppmärksamma information på www.tagibergslagen.se/trafikinformation, skyltar och utrop.`,
                value: `Inställt tåg-Buss ersätter, ingen tidtabell finns: Ditt tåg ${trainNumber} är inställt. Orsaken är ${reason}. Invänta ersättningsbuss. Uppmärksamma information på www.tagibergslagen.se/trafikinformation, skyltar och utrop.`
              },
              {
                text: `Inställt Tåg-hänvisning nästa avgång: Ditt tåg {{ tåg }} är inställt. Orsaken är {{ orsak }}. Du hänvisas till nästa avgång med Tåg i Bergslagen. Din nuvarande biljett gäller. För mer information se www.tagibergslagen.se.`,
                value: `Inställt Tåg-hänvisning nästa avgång: Ditt tåg ${trainNumber}  är inställt. Orsaken är ${reason}. Du hänvisas till nästa avgång med Tåg i Bergslagen. Din nuvarande biljett gäller.\n\nFör mer information se www.tagibergslagen.se.`
              }
            ]

      return templates
    },

    currentTrip() {
      return this.model?.trips?.find(x => x?.trip_uuid === this.uuid)
    }
  },

  methods: {
    isDiff(prop) {
      if (!this.currentTrip) return false
      const currentProp = this.currentTrip.data[prop] || null
      const formProp = this.form[this.uuid].data[prop] || null
      if (currentProp && formProp && prop === 'estimated_time_at_location') {
        return (
          format(new Date(currentProp), 'yyyy-MM-dd HH:mm') !==
          format(new Date(formProp), 'yyyy-MM-dd HH:mm')
        )
      }
      return currentProp !== formProp
    }
  }
}
</script>
